import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./ProviderTableAndMapContainer.scss";
import Button from "components/common/Button";
import ExpandToggleButton from "components/provider/widgets/ExpandToggleButton";
import ProviderClinicMap from "components/provider/widgets/ProviderClinicMap";
import * as OrgNodeTypes from "constants/OrgNodeTypes";

export default function ProviderTableAndMapContainer({
    canExpand = true,
    canGoUp = false,
    canViewProviderReports = false,
    children,
    highlightMarker,
    isExpanded = false,
    mapMarkers = [],
    markerChildren,
    nodeType,
    onChange,
    onClusterClick,
    onGoUp,
    onMarkerClick,
    onMarkerHoverEnd,
    onMarkerHoverStart,
    parentNodeType
}) {
    const [isTableExpanded, setIsTableExpanded] = useState(isExpanded);

    const handleClick = expanded => {
        setIsTableExpanded(expanded);
        if (onChange) {
            onChange(expanded);
        }
    }

    const backButtonText = () => {
        if (parentNodeType) {
            // If the parent node exists then button should say back to {parentNodeType}
            return parentNodeType;
        } else {
            switch (nodeType) {
                case OrgNodeTypes.REGION:
                case OrgNodeTypes.ABL:
                    return OrgNodeTypes.HQ; // Back to HQ
                case OrgNodeTypes.DISTRICT:
                    return OrgNodeTypes.REGION; // Back to Region
                case OrgNodeTypes.TERRITORY:
                    return OrgNodeTypes.DISTRICT; // Back to District
                case OrgNodeTypes.NHO:
                    return OrgNodeTypes.NHO_HQ; // Back to NHOHQ
                case OrgNodeTypes.KAM_DISTRICT:
                    return OrgNodeTypes.KAM_HQ; // Back to KAMHQ
                case OrgNodeTypes.KAM_TERRITORY:
                    return OrgNodeTypes.KAM_DISTRICT; // Back to KAMDistrict
                case OrgNodeTypes.MGR:
                    return OrgNodeTypes.ABL; // Back to ABL
                default:
                    return `${nodeType}s` // Back to {nodeType}s
            }
        }
    }

    const renderBackButton = () => {
        if (canGoUp && onGoUp) {
            return (
                <Button
                    onClick={onGoUp}
                    text
                    small
                >
                    <i className="fas fa-arrow-left"/>&nbsp;Back to {backButtonText()}
                </Button>
            );
        } else {
            return null; // No button for you, fish face!
        }
    };

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <div className="flex-1">{renderBackButton()}</div>
                <div className="flex-3 text-center">{canViewProviderReports ? `Provider Dashboard` : nodeType}</div>
            </div>
            <div className={classnames({
                [styles.content]: !isTableExpanded,
                [styles.expandedContent]: isTableExpanded,
            })}>
                <div className={classnames({
                    [styles.buttonContainer]: !isTableExpanded,
                    [styles.expandedButtonContainer]: isTableExpanded,
                })}>
                    {canExpand && (
                        <div className="full-width full-height" style={{ position: "relative" }}>
                            <ExpandToggleButton
                                isExpanded={isTableExpanded}
                                onClick={handleClick}
                            />
                        </div>
                    )}
                </div>
                <div className={classnames(styles.expandableTable, {
                    [styles.expanded]: isTableExpanded,
                })}>
                    {children} {/* Your collapsed table here */}
                </div>
                {/*{isTableExpanded ? (*/}
                {/*    <div className="full-width full-height" style={{ position: "relative", overflowY: "auto" }}>*/}
                {/*        {children} /!* Your expanded table here *!/*/}
                {/*    </div>*/}
                {/*) : (*/}
                {/*    <div style={{ position: "relative", width: "25%", height: "100%", overflowY: "auto" }}>*/}
                {/*        {children} /!* Your collapsed table here *!/*/}
                {/*    </div>*/}
                {/*)}*/}
                <div className={classnames({ 
                    [styles.map]: !isTableExpanded,
                    [styles.mapExpanded]: isTableExpanded && canViewProviderReports,
                    [styles.mapHidden]: isTableExpanded && !canViewProviderReports
                })}>
                    <ProviderClinicMap
                        markers={mapMarkers}
                        markerChildren={markerChildren}
                        onMarkerClick={onMarkerClick}
                        onClusterClick={onClusterClick}
                        highlightMarker={highlightMarker}
                        hoverStart={onMarkerHoverStart}
                        hoverEnd={onMarkerHoverEnd}
                    />
                </div>
            </div>
        </div>
    );
}

ProviderTableAndMapContainer.propTypes = {
    canExpand: PropTypes.bool,
    highlightMarker: PropTypes.number,
    mapBounds: PropTypes.object,
    nodeType: PropTypes.string,
    parentNodeType: PropTypes.string,
    onChange: PropTypes.func,
    onMarkerHoverEnd: PropTypes.func,
    onMarkerHoverStart: PropTypes.func,
    canViewProviderReports: PropTypes.bool
}
